import { Button, ComboBox, LoadingIndicator } from '@components';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { toast } from 'react-toastify';
import api from '../../../../common/services/api';
import './styles.css';

export const AbonoAnualPage = ({
  urlGetPDF,
  relatorio = 'Contracheque adiantamento Abono Anual',
}) => {
  const user = useSelector((state) => state.user);

  const navigate = useNavigate();
  const custom = useSelector((state) => state.customizaSistema);
  const [isLoading, setIsLoading] = useState(false);

  const [anoSelecionado, setAnoSelecionado] = useState('2025');

  const [habilitarPDF, setHabilitarPDF] = useState(false);

  useEffect(() => {
    setIsLoading(false);
    setHabilitarPDF(true);
  }, []);

  const opcoesAnosAbonoAnual = () => {
    const anoAtual =
      new Date().getFullYear() >= 2025 ? new Date().getFullYear() : 2025;
    const anosGerados = [];

    for (let i = 2025; i <= anoAtual; i += 1) {
      anosGerados.push(i.toString());
    }

    return anosGerados.reverse();
  };

  async function baixarArquivoPDF() {
    setIsLoading(true);

    try {
      await api
        .get(urlGetPDF, {
          responseType: 'arraybuffer',
          params: {
            matricula: user.matricula,
            ano: anoSelecionado,
            token: user.token,
          },
        })
        .then((res) => {
          const blob = new Blob([res.data], { type: 'application/pdf' });
          const link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.download = `${relatorio} ${anoSelecionado} participante - ${user.matricula}.PDF`;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        })
        .finally(() => {
          setIsLoading(false);
        });
    } catch (error) {
      toast.error(`Erro ao gerar ${relatorio}`);
    }
  }

  return (
    <>
      <h1 className="page-title mb-3">
        <strong>Contracheque adiantamento Abono Anual</strong>
      </h1>
      <hr className="my-4" />
      <div className="d-flex col-3 col-md-2 col-lg-1 justify-content-center">
        <Button
          className="justify-content-center mb-32"
          transparent
          color="orange"
          icon="arrow_back"
          onClick={() => navigate(-1)}
        >
          Voltar
        </Button>
      </div>
      <div className="card">
        <div className="card-body">
          <h2>
            <strong>Adiantamento de Abono Anual </strong>
          </h2>

          <div className="row col-12 col-md-8 col-lg-6 mb-4 mt-4">
            {!isLoading ? (
              <>
                <ComboBox
                  color={custom.nomeCorPrincipal}
                  label="Ano"
                  className="mt-3 col-12 col-md4 col-lg-6"
                  value={anoSelecionado}
                  onChange={setAnoSelecionado}
                  tooltip="Selecione o ano de referência"
                  options={opcoesAnosAbonoAnual().map((x) => {
                    return { value: x, label: x };
                  })}
                />

                {habilitarPDF && (
                  <Button
                    onClick={() => baixarArquivoPDF()}
                    className="ts-14 mb-2 col-6 mt-4"
                  >
                    Baixar
                  </Button>
                )}
              </>
            ) : (
              <LoadingIndicator />
            )}
          </div>
        </div>
      </div>
    </>
  );
};
